<template>
  <b-modal
    ref="sync-herotive-video-modal"
    id="sync-herotive-video-modal"
    class="sync-herotive-video-modal"
    size="xl"
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div
      class="d-flex justify-content-between top-modal"
      style="margin-top: 10px;"
    >
      <div>
        <h4 class="font-medium text-primary">
          Herotive Video
        </h4>
        <p class="mb-0 text-placeholder">
          Select videos from Herotive to add into your Creative Library.
        </p>
      </div>
      <div>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideModal"
        />
      </div>
    </div>
    <div class="choose-video-content mt-1">
      <div class="d-flex justify-content-between align-items-center my-1">
        <b-row class="align-items-center w-100 mx-0">
          <b-col
            cols="12"
            md="6"
            class="px-0"
          >
            <v-select
              v-model="sortSelected"
              :options="sortOptions"
              label="name"
              style="width: 100%"
              class="select-video-input"
              placeholder="Choose Identity"
              :clearable="false"
              :searchable="false"
              @input="fetchListVideoLibrary(false)"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <feather-icon
                    icon="ChevronDownIcon"
                    size="13"
                  />
                </span>
              </template>
              <template #selected-option="{ name }">
                <div
                  v-b-tooltip.hover.top.v-light.html
                  class="d-flex flex-column content-ad-account w-100"
                  :title="name ? name : '--'"
                >
                  <span
                    class="wrap-content"
                    style="margin-right: 4px"
                  >Sort by: {{ name }}</span>
                </div>
              </template>
              <template #option="{ name }">
                <div class="d-flex align-items-center">
                  <span>{{ name }}</span>
                </div>
              </template>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-input-group class="input-group-merge">
              <flat-pickr
                v-model="rangeDate"
                class="form-control"
                placeholder="Start date - End date"
                style="height: 42px"
                :config="{mode: 'range'}"
                @on-close="changeRangeDate"
              />
              <b-input-group-append
                v-if="fromDate && toDate"
                is-text
                class="close-icon"
              >
                <feather-icon
                  class="cursor-pointer"
                  icon="XIcon"
                  @click="clearSearchDate"
                />
              </b-input-group-append>
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  icon="CalendarIcon"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <div class="d-flex width-max">
          <btn-loading
            variant-convert="btn-submit-outline"
            pill
            class="d-flex align-items-center mr-1"
            style="height: 32px"
            @click="redirectCreateVideo"
          >
            <feather-icon
              class="button__icon mr-50 cursor-pointer"
              icon="PlusIcon"
            />
            <span>Create video</span>
          </btn-loading>
          <b-button
            size="sm"
            variant="outline-primary width-max"
            pill
            @click="handelClearVideo"
          >
            Clear selection
          </b-button>
        </div>
      </div>
      <div
        ref="videoScrollContainer"
        style="height: calc(100vh - 345px); overflow-y: scroll"
        @scroll="onScroll"
      >
        <div
          v-if="loadingVideo"
          class="d-flex justify-content-center"
        >
          <b-spinner
            variant="secondary"
            small
          />
        </div>
        <div v-else-if="allVideosHerotive.length > 0">
          <div class="video-grid">
            <div
              v-for="video in allVideosHerotive"
              :key="video._id"
              class="video-card position-relative"
              :class="{ 'selected': isVideoSelected(video) }"
              @click="toggleVideo(video)"
            >
              <div
                class="video-thumbnail"
                @mouseenter="onHoverStart(video)"
                @mouseleave="onHoverEnd"
              >
                <!-- Small checkbox indicator -->
                <div
                  class="select-checkbox"
                  :class="{ checked: isVideoSelected(video) }"
                >
                  <feather-icon
                    v-if="isVideoSelected(video)"
                    icon="CheckIcon"
                    size="14"
                    class="text-white"
                  />
                </div>

                <template v-if="playingVideoId === video._id">
                  <div
                    class="position-relative"
                    style="width: 100%; height: 100%;"
                  >
                    <video
                      :ref="`video-${video._id}`"
                      :src="video.previewUrl"
                      autoplay
                      :muted="videoMutedStates[video._id] !== false"
                      loop
                      playsinline
                      style="width: 100%; height: 100%; object-fit: cover;"
                    />
                    <feather-icon
                      :icon="videoMutedStates[video._id] !== false ? 'VolumeXIcon' : 'Volume2Icon'"
                      size="24"
                      class="video-sound-icon cursor-pointer"
                      @click.stop="toggleVideoSound(video._id)"
                    />
                  </div>
                </template>
                <template v-else>
                  <img
                    :src="video.thumbnailUrl"
                    class="thumbnail-image"
                  >
                </template>
                <!-- Remove full overlay selection -->
              </div>
            </div>
          </div>
          <!-- Load More Loading -->
          <div
            v-if="loadingMore"
            class="d-flex justify-content-center py-3"
          >
            <b-spinner
              variant="secondary"
              small
            />
          </div>
        </div>

        <!-- No Videos State -->
        <div
          v-else-if="allVideosHerotive.length === 0"
          class="text-center py-4"
        >
          <b-img
            alt="No account"
            class="img"
            :src="require('@/assets/images/common/no-data-table.svg')"
          />
        </div>
      </div>

    </div>

    <!-- Action Buttons -->
    <template #modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <p>All videos ({{ videosSelected.length }} selected)</p>
        <div class="d-flex justify-content-end">
          <btn-loading
            class="mr-1 border-0"
            variant-convert="btn-back"
            pill
            @click="hideModal"
          >
            Cancel
          </btn-loading>
          <btn-loading
            class="ml-1"
            variant-convert="btn-submit"
            type="submit"
            pill
            :loading="loading"
            :disabled="videosSelected.length === 0"
            @click="confirmSelection"
          >
            Apply
          </btn-loading>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
/* eslint-disable no-underscore-dangle,camelcase */
import { createNamespacedHelpers } from 'vuex'
import {
  BModal,
  VBTooltip,
  BImg,
  BSpinner,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BCol,
  BRow,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import Ripple from 'vue-ripple-directive'
import { toastification } from '@core/mixins/toast'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import dayjs from 'dayjs'

const { mapActions, mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BButton,
    BSpinner,
    BImg,
    BtnLoading,
    BModal,
    vSelect,
    flatPickr,
    BInputGroupAppend,
    BInputGroup,
    BCol,
    BRow,
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  mixins: [toastification],

  props: {
    campaigns: {
      type: Array,
      default: () => [],
      required: true,
    },

    currentAdGroup: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      videosSelected: [],

      playingVideoId: null,
      videoMutedStates: {},

      hasMore: false,
      loadingMore: false,
      loadingVideo: false,
      allVideosHerotive: [],
      scrollPosition: 0, // Store scroll position for load more

      currentPage: 1,

      rangeDate: null,
      fromDate: null,
      toDate: null,

      sortSelected: { name: 'Creation time (Most to least recent)', value: 'desc' },
      sortOptions: [
        { name: 'Creation time (Most to least recent)', value: 'desc' },
        { name: 'Creation time (Least to most recent)', value: 'asc' },
      ],
    }
  },

  computed: {
    ...mapGetters(['listVideoLibrary', 'status', 'message', 'loading']),
  },

  methods: {
    ...mapActions(['syncVideoToAdAccount', 'getListVideoLibrary']),
    resetModal() {
      this.videosSelected = []

      this.loadingMore = false
      this.loadingVideo = false
      this.scrollPosition = 0

      this.currentPage = 1
      this.rangeDate = null
      this.fromDate = null
      this.toDate = null
      this.sortSelected = { name: 'Creation time (Most to least recent)', value: 'desc' }
    },

    hideModal() {
      this.$refs['sync-herotive-video-modal'].hide()
      this.resetModal()
    },

    async showModal() {
      this.$refs['sync-herotive-video-modal'].show()
      await this.fetchListVideoLibrary(false)
    },

    isVideoSelected(video) {
      return this.videosSelected.includes(video._id)
    },

    onHoverStart(video) {
      this.playingVideoId = video._id
    },

    onHoverEnd() {
      this.playingVideoId = null
    },

    toggleVideoSound(videoId) {
      // Toggle muted state for this video
      this.$set(this.videoMutedStates, videoId, this.videoMutedStates[videoId] === false)
      // Update the video element's muted property
      const videoElement = this.$refs[`video-${videoId}`]
      if (videoElement && videoElement[0]) {
        videoElement[0].muted = this.videoMutedStates[videoId] !== false
      }
    },

    onScroll(event) {
      const { target } = event
      const { scrollTop, scrollHeight, clientHeight } = target

      // Check if scrolled to bottom (with 100px threshold)
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100

      if (isNearBottom && this.hasMore && !this.loadingMore && !this.loading) {
        // Save current position to restore after items append
        this.savedScrollTop = this.$refs.videoScrollContainer ? this.$refs.videoScrollContainer.scrollTop : 0
        this.waitingForLoadMore = true
        this.fetchListVideoLibrary(true)
      }
    },

    changeRangeDate(selectedDates) {
      if (selectedDates.length === 2) {
        const [fromDateStr, toDateStr] = selectedDates
        this.fromDate = dayjs(fromDateStr).format('YYYY-MM-DD')
        this.toDate = dayjs(toDateStr).format('YYYY-MM-DD')
        this.fetchListVideoLibrary(false)
      }
    },

    clearSearchDate() {
      this.rangeDate = null
      this.fromDate = null
      this.toDate = null
      this.fetchListVideoLibrary(false)
    },

    async fetchListVideoLibrary(isLoadMore = false) {
      if (isLoadMore) {
        this.currentPage += 1
        this.loadingMore = true
      } else {
        this.currentPage = 1
        this.loadingVideo = true
      }

      const params = {
        page: this.currentPage,
        limit: 20,
        unSyncToAdAccId: this.$route.query?.advertiserId,
        sortByDate: this.sortSelected.value,
        ...(this.fromDate && { fromDate: this.fromDate }),
        ...(this.toDate && { toDate: this.toDate }),
        types: ['AVATAR_PRODUCT', 'VOICEOVER', 'DUBBING', 'MANUAL_UPLOAD_ADS_VIDEO'],
      }

      await this.getListVideoLibrary(params)

      if (this.listVideoLibrary?.content) {
        const listVideo = this.listVideoLibrary.content
        if (isLoadMore) {
          this.allVideosHerotive = [...this.allVideosHerotive, ...listVideo]
        } else {
          this.allVideosHerotive = listVideo
        }

        if (this.listVideoLibrary.total > this.allVideosHerotive.length) {
          this.hasMore = true
        } else {
          this.hasMore = false
        }
      }

      if (isLoadMore) {
        this.loadingMore = false
      } else {
        this.loadingVideo = false
      }
    },

    async redirectCreateVideo() {
      localStorage.setItem('campaigns', JSON.stringify(this.campaigns))
      this.$router.push({ path: '/create-campaign-video', query: { ...this.$route.query, campaignIndex: this.currentAdGroup.campaignIndex, adgroupIndex: this.currentAdGroup.adgroupIndex } })
    },

    handelClearVideo() {
      this.videosSelected = []
    },

    toggleVideo(video) {
      const index = this.videosSelected.findIndex(id => id === video._id)

      if (index > -1) {
        this.videosSelected.splice(index, 1)
      } else {
        this.videosSelected.push(video._id)
      }
    },

    async confirmSelection() {
      const params = {
        advertiserId: this.$route.query?.advertiserId,
        localVideoIds: this.videosSelected,
      }
      await this.syncVideoToAdAccount(params)
      if (this.status) {
        this.toastSuccess('Video synced successfully')
        this.hideModal()
        this.$emit('fetchListVideo', false)
      } else {
        this.toastFailure(this.message)
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
#sync-herotive-video-modal {
  .modal-content {
    height: 90vh;
    width: 1053px;
    margin: auto;

    .modal-body {
      height: 100%;
    }

    .form-control:focus, .input-group:focus-within .form-control {
      border-color: #e0e0e5 !important;
    }

    .close-icon {
      .input-group-text {
        padding-left: 0;
        padding-right: 0;
      }
    }

  }

  .video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
  }

  .video-card {
    border: 2px solid #fff;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;

    &:hover {
      border-color: #7367f0;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.15);
    }

    &.selected {
      border-color: #7367f0;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
    }
  }

  .video-thumbnail {
    position: relative;
    width: 100%;
    height: 320px;
    overflow: hidden;

    .select-checkbox {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: 1px solid rgba(255, 255, 255, 0.9);
      background: rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      justify-content: center;
      backdrop-filter: blur(2px);

      &.checked {
        background: #7367f0;
        border-color: #7367f0;
      }
    }

    .thumbnail-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .video-info {
    padding: 12px;

    .video-title {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.3;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .selection-summary {
    border: 1px solid #dee2e6;

    .selected-videos-list {
      max-height: 200px;
      overflow-y: auto;
    }

    .selected-video-item {
      padding: 8px 0;
      border-bottom: 1px solid #f1f1f1;

      &:last-child {
        border-bottom: none;
      }
    }

    .selected-thumbnail {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  .select-video-input {
    .vs__selected-options {
      width: 88%;
      .vs__selected {
        width: 88%;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.video-card {
  .sync-button {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover .sync-button {
    opacity: 1;
  }
}

.video-thumbnail {
  position: relative;

  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
    pointer-events: none; /* Allow video to still play underneath */
  }

  .select-checkbox {
    z-index: 2; /* Above overlay */
  }
}

.video-sound-icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 4px;
  color: white;
  z-index: 3;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
}

.wrap-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
